import axios from 'axios';
import { getPublicApiBase } from './publicApi';
import { resolveBrandingLogoImageUrl } from './publicAssetUrl';

/**
 * Returns absolute URL for the tenant branding logo, or null (public API — no auth).
 * Uses /api/public/branding/file so print/PDF and dev proxy work without /uploads.
 */
export async function fetchBrandingLogoAbsoluteUrl() {
  try {
    const base = getPublicApiBase().replace(/\/+$/, '');
    const r = await axios.get(`${base}/branding`);
    const path = r.data?.data?.portalLogoPath;
    if (!path || !String(path).trim()) return null;
    return resolveBrandingLogoImageUrl(String(path).trim());
  } catch {
    return null;
  }
}
